/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practicing under real exam conditions with a 1-hour time limit.`)
};

const es_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practicar en condiciones reales de examen con un límite de 1 hora.`)
};

const de_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter echten Prüfungsbedingungen mit einer 1-Stunden-Zeitgrenze üben.`)
};

const nl_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefenen onder echte examenomstandigheden met een tijdslimiet van 1 uur.`)
};

const fr_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S’entraîner dans des conditions d’examen réelles avec une limite d’une heure.`)
};

const it_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercitarsi in condizioni d'esame reali con un limite di tempo di 1 ora.`)
};

const pt_br2_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar em condições reais de prova com um limite de tempo de 1 hora.`)
};

const pt_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praticar em condições reais de exame com um limite de tempo de 1 hora.`)
};

const ja_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1時間の制限時間で実際の試験条件を想定して練習する。`)
};

const zh_timer_u1h_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在1小时时间限制下，按真实考试条件进行练习。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_use2", locale)
	if (locale === "en") return en_timer_u1h_use2(inputs)
	if (locale === "es") return es_timer_u1h_use2(inputs)
	if (locale === "de") return de_timer_u1h_use2(inputs)
	if (locale === "nl") return nl_timer_u1h_use2(inputs)
	if (locale === "fr") return fr_timer_u1h_use2(inputs)
	if (locale === "it") return it_timer_u1h_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_use2(inputs)
	if (locale === "pt") return pt_timer_u1h_use2(inputs)
	if (locale === "ja") return ja_timer_u1h_use2(inputs)
	return zh_timer_u1h_use2(inputs)
};